import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemDescription.css'

/**
 * Item Description is the secondary, muted line of text in an
 * [Item](/components/item/). It is clamped to two lines.
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the description text.
 */
@customElement('nord-item-description')
export default class ItemDescription extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-description': ItemDescription
  }
}
